import api from '@/lib/axios'

export interface LocalizedString {
    tr: string
    en?: string
    fr?: string
    es?: string
    ru?: string
    nl?: string
    ar?: string
}

export interface ProductionStep {
    _id?: string
    title: LocalizedString
    duration: LocalizedString
    description: LocalizedString
    efficiency: number
    icon?: string
}

export interface ProductionStat {
    _id?: string
    value: string
    label: LocalizedString
}

export interface ProductionPage {
    _id?: string
    hero: {
        title: LocalizedString
        description: LocalizedString
    }
    steps: ProductionStep[]
    stats: ProductionStat[]
    createdAt?: string
    updatedAt?: string
}

export const productionService = {
    getProductionPage: async () => {
        const res = await api.get<ProductionPage>('/production')
        return res.data
    },
    updateProductionPage: async (data: Partial<ProductionPage>, translate: boolean = false) => {
        const res = await api.put<ProductionPage>('/production', data, { params: { translate } })
        return res.data
    }
}
